<template>
  <div class="lbv-update-parameters animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card v-if="$store.getters.roleID === '4'">
          <h1 class="lbv-page-title updateParameters">
            Devices Matlab Parameters
          </h1>
          <div class="updateParametersInputs">
            <div
              class="section"
              style="margin-top:20px; min-height:100px"
            >
              <b-row class="header">
                <b-col
                  cols="12"
                  style="text-align: center; margin-top:10px"
                >
                  <h3 class="form-label">
                    Description
                  </h3>
                </b-col>
              </b-row>
              <p>
                This page is provided so that you can update matlab parameters on device. Those will be sent to matlab with temperature log payload to calculate leak. Any action will trigger automatic updates on other sections
                <br>
                <br>LeakBot section:
                - LeakBot id - populate to display list of parameters of device in "Device parameters" section
                <br>- Filter by parameter name - filter the device parameter list by name of parameter (case sensitive) in "Device parameters" section
                <br>
                <br>Parameters section:
                <br>- Filter "Parameter Name" list - filters "Parameter Name" list 
                <br>- Parameter Name - select parameter to be updated on device
                <br>- Parameter Value - populate value to update device. If parameter is array of values just pass parameters separated by comma e.g. 2, 3.5, 21 (no need to add brackets e.g. [2, 3.5, 21])
                <br>- Update device - triggers update of parameter on device. Automatically updates "Device parameters" section
                <br>
                <br>Device parameters section:
                <br>- When you click on any row of available parameters of device the "Parameters" section will get populated automatically
              </p>
            </div>
            <form @submit.prevent="updateDevice">
              <b-row class="push-down">
                <!--b-col cols="6" style="display: flex; align-items: stretch;"-->
                <b-col cols="6">
                  <div class="section">
                    <b-row class="header">
                      <b-col
                        cols="12"
                        style="text-align: center; margin-top:10px"
                      >
                        <h3 class="form-label">
                          LeakBot
                        </h3>
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label class="form-label">LeakBot id:</label>
                      </b-col>
                      <b-col cols="8">
                        <input
                          v-model="leakbotId"
                          type="text"
                          class="form-control"
                          @change="leakbotIdChange"
                        >
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label>Filter by parameter name:</label>
                      </b-col>
                      <b-col cols="8">
                        <input
                          v-model="filterParameterName"
                          type="text"
                          class="form-control full-width"
                          @input="filterName"
                        >
                      </b-col>
                    </b-row>
                  </div>
                </b-col>

                <!--b-col cols="6" style="display: flex; align-items: stretch;"-->
                <b-col cols="6">
                  <div class="section">
                    <b-row class="header">
                      <b-col
                        cols="12"
                        style="text-align: center; margin-top:10px"
                      >
                        <h3 class="form-label">
                          Parameters
                        </h3>
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label>Filter "Parameter Name" list:</label>
                      </b-col>
                      <b-col cols="8">
                        <input
                          v-model="filterParameterNameList"
                          type="text"
                          class="form-control full-width"
                          @input="changeFilterParameterNameList"
                        >
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label class="form-label">Parameter Name:</label>
                      </b-col>
                      <b-col cols="8">
                        <select
                          v-model="matlabParameterName"
                          class="form-control full-width"
                          @change="matlabParameterChange"
                        >
                          <option
                            v-for="parameter in matlabParameterList"
                            :key="parameter.parameter_name"
                            :value="{ name: parameter.parameter_name, type: parameter.parameter_type, min: parameter.min, max: parameter.max, default: parameter.default }"
                          >
                            {{ parameter.parameter_name }}
                          </option>
                        </select>
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label>Parameter Value:</label>
                      </b-col>
                      <b-col cols="8">
                        <input
                          v-model="matlabParameterValue"
                          type="text"
                          class="form-control"
                        >
                      </b-col>
                    </b-row>

                    <b-row class="push-down">
                      <b-col cols="4">
                        <label>Min val: {{ matlabParameterName.min }}</label>
                      </b-col>

                      <b-col cols="4">
                        <label>Max val: {{ matlabParameterName.max }}</label>
                      </b-col>

                      <b-col cols="4">
                        <label>Def val: {{ matlabParameterName.default }}</label>
                      </b-col>
                    </b-row>

                    <b-row
                      class="push-down"
                      style="position: absolute; bottom: 20px; right: 35px"
                    >
                      <b-col cols="12">
                        <button
                          type="submit"
                          class="btn btn-primary parameterUpdate"
                        >
                          <span>Update device</span>
                        </button>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>

              <!--b-row class="push-down">
                <b-alert :show="errorMessage != ''" variant="danger">{{errorMessage}}</b-alert>
              </b-row-->

              <div
                class="section"
                style="margin-top:20px;"
              >
                <b-row class="header">
                  <b-col
                    cols="12"
                    style="text-align: center; margin-top:10px"
                  >
                    <h3 class="form-label">
                      Device parameters
                    </h3>
                  </b-col>
                </b-row>

                <b-table
                  responsive
                  striped
                  hover
                  :items="deviceParameterList"
                  :fields="fields"
                  @row-clicked="myRowClickHandler"
                />
              </div>
            </form>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import deviceMatlabParametersMixin from '../mixins/deviceMatlabParametersMixin'

export default {
  name: 'ParameterList',
  mixins: [deviceMatlabParametersMixin]
}
</script>

<style media="screen">


  .lbv-update-parameters .updateParametersInputs label {
    font-size: 0.8rem;
    float: left;
    margin-right: 4px;
    margin-top: 9px;
    font-weight: bold;
  }

  .updateParametersInputs .push-down {
    margin-top: 1rem;
  }

  .updateParametersInputs .section {
    background-color: #F0F0F0;
    border-radius: 15px;
    padding: 7px 15px 15px 15px;
    box-shadow:5px 5px grey;
    min-height:400px
  }

  .updateParametersInputs .section .header{
    background-color: #E0E0E0;
    margin-top: -7px;
    border-radius: 15px 15px 0px 0px;
    height: 50px
  }

  .updateParametersInputs .form-control {
    width: 100%;
    border-radius: 8px
  }

  .updateParametersInputs .form-label {
    align-self: right;
  }

  .parameterUpdate {
    align-self: center;
    border-radius: 8px;
    width: 200px;
  }

</style>
